import styled from '@emotion/styled';
import { useResource } from '@landsbankinn/l16n';
import {
  Column,
  device,
  Row,
  TagFilterCheckbox,
  useMedia,
} from '@landsbankinn/ui';
import React from 'react';
import { AtmType } from '../../../../__generated__/globalTypes';
import res from './AtmFilter.res';

interface IProps {
  selectedAtmTypes: AtmType[];
  setSelectedAtmTypes: React.Dispatch<React.SetStateAction<AtmType[]>>;
}

const Host = styled(Row)`
  margin-bottom: 40px;
`;

const StyledTagFilterCheckbox = styled(TagFilterCheckbox)`
  width: 100%;
  margin-right: 10px;
  margin-bottom: 20px;
  @media ${device.tablet} {
    width: 160px;
  }
`;

export const CheckboxContainer: React.FC = ({ children }) => {
  const isMobile = useMedia('sm');
  if (isMobile) {
    return (
      <Column gutter={20} width={1 / 2}>
        {children}
      </Column>
    );
  }
  return <>{children}</>;
};

export const AtmTypesFilter: React.FC<IProps> = ({
  selectedAtmTypes,
  setSelectedAtmTypes,
}) => {
  const { r } = useResource();
  const services = () => {
    const types: AtmType[] = [];
    for (const service in AtmType) {
      const myService: AtmType = AtmType[service] as AtmType;

      types.push(myService);
    }
    return types.sort((a, b) => {
      if (b === AtmType.Atm) {
        return 1;
      }
      if (a === AtmType.DepositAtm) {
        return -1;
      }
      if (b === AtmType.CurrencyAtm) {
        return 1;
      }
      if (a === AtmType.GiftCardAtm) {
        return -1;
      }
      if (a === AtmType.CoinCounterAtm) {
        return 1;
      }
      if (a === AtmType.CoinRollAtm) {
        return 1;
      }
      if (a === AtmType.CorporateDepositAtm) {
        return 1;
      }
      return -1;
    });
  };

  return (
    <Host>
      {services().map((service) => {
        if (r(res[service])) {
          return (
            <CheckboxContainer>
              <StyledTagFilterCheckbox
                id={service}
                checked={selectedAtmTypes.includes(service)}
                label={r(res[service])}
                onChange={(checked) => {
                  if (checked) {
                    setSelectedAtmTypes([...selectedAtmTypes, service]);
                    return;
                  }
                  setSelectedAtmTypes(
                    selectedAtmTypes.filter((i) => i !== service),
                  );
                }}
              />
            </CheckboxContainer>
          );
        }
      })}
    </Host>
  );
};
